var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-divider'), _c('v-progress-circular', {
    staticClass: "my-4",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : [_vm._l(_vm.weaponIDs, function (weaponID) {
    return [_c('v-divider'), _c('Weapon', {
      key: "home-weapon-".concat(weaponID),
      attrs: {
        "id": weaponID
      }
    })];
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }